module.exports = __webpack_public_path__ + "img/noq-map-pin-my-location.9dc06e5a.svg";